import React from 'react';

import Skel from '../../components/skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { driverTypeFromHistory } from '../../services/driver';
import HomologationErrorIndicator from './homologation-error';

import * as fmt from '../../utils/fmt';

import styles from './styles.css';

function DriverInfoHeadline({ driver, history, homologationError, loading }) {
  const hasDriverType = !!(
    driverTypeFromHistory[history.driverKind] ||
    driver.driverRelationshipType
  );

  const driverType = driverTypeFromHistory[history.driverKind] || driver.driverRelationshipType
    && driver.driverRelationshipType.description;

  return <Grid spacing={32} container>
    {
      driver.id
        ? <Grid item sm={2}>
          <div className={styles.gridCell}>
            <Typography variant="subtitle2">
              Código
            </Typography>

            {driver.id}
          </div>
        </Grid>
        : null
    }

    <Grid item sm={4}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          Nome
        </Typography>

        <Skel loading={loading}>{history.driverName || driver.name}</Skel>
      </div>
    </Grid>

    <HomologationErrorIndicator error={homologationError} loading={loading} />

    { hasDriverType &&
      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Tipo Motorista
          </Typography>

          <Skel loading={loading}>{driverType}</Skel>
        </div>
      </Grid>
    }

    <Grid item sm={2}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          CPF
        </Typography>

        <Skel loading={loading}>{fmt.cpf(history.driverCPF || driver.cpf || '')}</Skel>
      </div>
    </Grid>

    <Grid item sm={2}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          Data Nascimento
        </Typography>

        <Skel loading={loading}>{fmt.dateOnly(history.driverBirth || driver.birth)}</Skel>
      </div>
    </Grid>
  </Grid>;
}

function DriverInfoDetails({ driver, history, loading }) {
  return <Grid container>
    <Grid item sm={2}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          RG
        </Typography>

        <Skel loading={loading}>{history.driverRg || driver.rg}</Skel>
      </div>
    </Grid>

    <Grid item sm={1}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          UF
        </Typography>

        <Skel loading={loading}>
          {history.driverRgState || driver.city && driver.city.state.abbrev}
        </Skel>
      </div>
    </Grid>

    <Grid item sm={3}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          Nome do Pai
        </Typography>

        <Skel loading={loading}>{history.driverFather || driver.father}</Skel>
      </div>
    </Grid>

    <Grid item sm={3}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          Nome da Mãe
        </Typography>

        <Skel loading={loading}>{history.driverMother || driver.mother}</Skel>
      </div>
    </Grid>

    <Grid item sm={2}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          Telefones
        </Typography>

        <Skel loading={loading}>
          {history.driverPhone || driver.phones && driver.phones.map(rec => rec.phone).join(', ')}
        </Skel>
      </div>
    </Grid>
  </Grid>;
}

function DriverInfoCNH({ driver, history, loading }) {
  return <>
    <Typography
      className={styles.mdSectionTitle}
      variant="subtitle1"
      component="h5"
      color="primary"
    >
      Carteira de Habilitação
    </Typography>

    <Grid spacing={32} container>
      <Grid item md={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Número CNH
          </Typography>

          <Skel loading={loading}>{history.driverCNH || driver.cnh}</Skel>
        </div>
      </Grid>

      <Grid item md={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Categoria CNH
          </Typography>

          <Skel loading={loading}>{history.driverCNHCategory || driver.cnhCategory}</Skel>
        </div>
      </Grid>

      <Grid item md={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Cód. Segurança CNH
          </Typography>

          <Skel loading={loading}>{history.driverCNHSecurity || driver.cnhSecurity}</Skel>
        </div>
      </Grid>

      <Grid item md={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Validade CNH
          </Typography>

          <Skel loading={loading}>
            {fmt.dateOnly(history.driverCNHValidity || driver.cnhValidity)}
          </Skel>
        </div>
      </Grid>
    </Grid>
  </>;
}

export default function DriverDetails({ driver = {}, history = {}, homologationError = null }) {
  const loading = !(driver.id || history.driverName);
  const props = { driver, history, homologationError };

  return <>
    <Typography variant="subtitle1" component="h5" color="primary">
      Dados do Motorista
    </Typography>

    <DriverInfoHeadline loading={loading} {...props} />
    <DriverInfoDetails loading={loading} {...props} />
    <DriverInfoCNH loading={loading} {...props} />
  </>;
}
